import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { worker } from './mocks/browers';
import { DEV_MODE_COOKIE_NAME } from '@utils/const';
import { getCookie } from '@utils/cookie';

const isMockMode = getCookie(DEV_MODE_COOKIE_NAME) === 'true';
if (isMockMode) {
  worker.start();
}

dayjs.extend(utc);
dayjs.extend(timezone);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(<App />);
